// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2AUEB","approved":"Status_approved__1mohV","rejected":"Status_rejected__1XXDe","expired":"Status_expired__1BO0T","label":"Status_label__4fDyC"};